import { jsx as _jsx } from "react/jsx-runtime";
import { ItemWorkflowTable } from './ItemWorkflowTable';
import { useMemo } from 'react';
import { useCtrlFSearchPopoverStore } from '../CtrlFSearchPopover/business';
// TODO: check if it is possible to make a single FilterableItemWorkflowTable component instead of two similar version.
const FilterableItemWorkflowTable = ({ data, fieldsToFilterBy, ...props }) => {
    const isCtrlFSearchPopoverOpen = useCtrlFSearchPopoverStore((state) => state.open);
    const filterSearchTerm = useCtrlFSearchPopoverStore((state) => state.searchTerm);
    const filteredItems = useMemo(() => {
        if (!data)
            return [];
        const searchTerm = filterSearchTerm.toLocaleLowerCase();
        // (simple case)
        // return data.filter(
        // 	(item) =>
        // 		item.brand.toLowerCase().includes(searchTerm) ||
        // 		item.article.toLowerCase().includes(searchTerm) ||
        // 		item.name.toLowerCase().includes(searchTerm)
        // );
        return data.filter((item) => fieldsToFilterBy.some((fieldName) => (typeof item[fieldName] === 'string' ? item[fieldName] : '').toLowerCase().includes(searchTerm)));
        // Uncomment if we need to search by numeric fields also. For dates it should be reworked.
        // return data.filter((item) =>
        // 	fieldsToFilterBy.some((fieldName) =>
        // 		(typeof item[fieldName] === 'string' ? item[fieldName] : typeof item[fieldName] === 'number' ? item[fieldName].toString() : '')
        // 			.toLowerCase()
        // 			.includes(searchTerm)
        // 	)
        // );
    }, [data, fieldsToFilterBy, filterSearchTerm]);
    return _jsx(ItemWorkflowTable, { ...props, data: filteredItems, disableCatchWindowFocus: isCtrlFSearchPopoverOpen });
};
export { FilterableItemWorkflowTable };
